module.exports = __webpack_public_path__ + "img/subscription-form-bg.69958f1.png";